<template>
  <div>
    <div class="page_header">
      <div class="header_top media_display">
        <div class="container_box header_top">
          <div class="row">
            <div class="fl top_left">
              <span>欢迎来到日照人力资源交易平台！</span>
              <span>{{$moment(new Date()).format('ll')}} &nbsp;&nbsp;{{$moment(new Date()).format('dddd')}}</span>
            </div>
            <div class="fr ar top_right">
              <div v-if="isLogin==null">
                <a class="xbtn" @click='goLogin'>登录</a> |
                <a class="lang_register" @click="goRegister">注册</a>
              </div>
              <div id="topEnterBox" @mouseover="topEnterShow=true" @mouseout="topEnterShow=false">
                <div v-if="isLogin!=null" class="enterInfo" id="enterInfo" @click="openNews">
                  <div class="img_box">
                    <img src="../assets/images/user-avatar.png" v-if="loginType==3">
                    <img :src="companyLogo" v-if="loginType!=3">                   
                  </div>
                  <div>{{username}}</div>
                </div>
                <ul class="enterInfolist" id="enterInfolist" v-show='topEnterShow'> 
                  <li @click="toEntercenter" v-if="loginType!=3">企业中心</li>
                  <li @click="toEnterpercenter" v-else-if="loginType==3">个人中心</li>
                  <li @click="getQuit">退出登录</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="header_nav">
        <div class="container_box bg_white">
          <div class="row">
            <div class="logo_box fl">
              <router-link to="/trade/index" tag="a">
                <img style="height:40px" src="../assets/images/logo-trade.png" alt="">
              </router-link>
            </div>
            <div class="nav_box fr media_display">
              <a @click='goHome' :class="{'active':currentPath=='/trade/index'}">首页</a>
              <a @click='goOrgan' :class="{'active':currentPath=='/trade/organ'}">服务机构</a>
              <a @click='goSupplyDemand' :class="{'active':currentPath=='/trade/supply-demand'||currentPath=='/trade/supply-demand-detail'||currentPath=='/trade/supply-demand-publish'}">供需对接</a>
              <a @click='goRecruit' :class="{'active':currentPath=='/trade/enter-recruit'||currentPath=='/trade/enter-recruit-detail'||currentPath=='/trade/enter-recruit-publish'}">就业服务</a>
              <!-- <a @click='goProduct' :class="{'active':currentPath=='/trade/product-service'}">产品服务</a> -->
              <a @click='goAbout' :class="{'active':currentPath=='/trade/about-us'}">关于我们</a>
            </div>
            <!-- 小屏幕导航 -->
            <div class="media_nav_icon fr" @click='smallScreen = true'><img src="../assets/images/icon_nav.png" alt=""></div>
            <div class="media_nav_box" v-show="smallScreen">
              <div class="btn_close" @click="smallScreen = false"><img src="../assets/images/icon_close.png" alt=""></div>
              <div class="nav_main">
                <a @click='goHome' :class="{'active':currentPath=='/trade/index'}" >首页</a>
                <a @click='goOrgan' :class="{'active':currentPath=='/trade/organ'}" >服务机构</a>
                <a @click='goSupplyDemand'  :class="{'active':currentPath=='/trade/supply-demand'||currentPath=='/trade/supply-demand-detail'||currentPath=='/trade/supply-demand-publish'}">供需对接</a>
                <a @click='goRecruit' :class="{'active':currentPath=='/trade/enter-recruit'||currentPath=='/trade/enter-recruit-detail'||currentPath=='/trade/enter-recruit-publish'}">就业服务</a>
                <!-- <a @click='goProduct' :class="{'active':currentPath=='/trade/product-service'}">产品服务</a> -->
                <a @click='goAbout' :class="{'active':currentPath=='/trade/about-us'}">关于我们</a>
              </div>
              <div class="login">
                <div v-if="isLogin==null">
                  <a @click='goLogin'>登录</a>
                  <a @click="goRegister">注册</a>
                </div>
                <div v-else>
                  <div class="avatar" @click="goMine">
                    <div class="img_box">
                      <img src="../assets/images/logo_s.png" v-if="loginType==3">   
                      <img :src="companyLogo" v-if="loginType!=3">  
                    </div>
                    <div>{{username}}</div>
                  </div>
                  <a @click="getQuit" class="lang_center3">退出登录</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      weather: {
        date: "",
        week: "",
        weather: ""
      },
      isLogin: null,
      username: "",
      loginType: "1",
      companyLogo: "",
      topEnterShow: false,
      navIndex:0,
      smallScreen:false,
    };
  },
  methods: {
    // 获取天气
    getWeather() {
      this.$http.get(this, "/noAuth/webIndex/weather").then(res => {
        if (res) {
          this.weather.date = res.result[0].days;
          this.weather.week = res.result[0].week;
          this.weather.weather = res.result[0].weather;
        }
      });
    },  
    //中英文切换 
    tabEn: function () {
      if(this.$i18n.locale=='zh'){
        this.$i18n.locale = 'en' 
      }else{       
        this.$i18n.locale = 'zh' 
      }    
    }, 
    // 初始化页面头部数据
    getLoginData() {
      if (localStorage.getItem("token") != null) {
        this.isLogin = localStorage.getItem("token");
        this.username = localStorage.getItem("username");
        this.loginType = localStorage.getItem("type");
        this.companyLogo = localStorage.getItem("logo");
      }
    },
    goLogin() {
      this.$router.push("/login");
    },
    goRegister(){
      this.$router.push("/register");
    },
    // 退出登录
    getQuit() {
      this.$confirm('您确定要退出登录?', '退出登录', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.clear();
        location.reload();
      }).catch(() => {         
      });
    },
    // 导航
    goHome(){
      this.$router.push('/trade/index');
      this.smallScreen = false;
    },
    goRecruit(){
      this.$router.push('/trade/enter-recruit');
      this.smallScreen = false;
    },
    goProduct(){
      this.$router.push('/trade/product-service');
      this.smallScreen = false;
    },
    goAbout(){
      this.$router.push('/trade/about-us');
      this.smallScreen = false;
    },
    goOrgan(){
      this.$router.push('/trade/organ');
      this.smallScreen = false;
    },
    goSupplyDemand(){
      this.$router.push('/trade/supply-demand');
      this.smallScreen = false;
    },
    toEntercenter(){
      this.$router.push('/trade/etprise-center/business-need')
    },
    toEnterpercenter(){
      this.$router.push('/trade/person-center');
    },
    goMine(){
      if(this.loginType==3){
        this.$router.push('/trade/person-center')
      }else{
        this.$router.push('/trade/etprise-center/business-need')
      }
      this.smallScreen = false;
    },
    openNews(){
      if(sessionStorage.getItem('unReadnum')>0 ){
        if(localStorage.getItem('type')==3){     
          window.sessionStorage.setItem("personCenterType",2)
          this.$router.push({path:'/person-center'});
        }
        if(localStorage.getItem('type')!=3){
          window.sessionStorage.setItem("enterCenterType",7)
          this.$router.push({path:'/enter-center'});
        }
      }
      
    },
  },
  destroyed () {
  },
  computed:{
    currentPath(){
      return this.$route.path;
    }
  },
  created() {
    // this.currentPath = this.$route.path;
    // this.getWeather();
    this.getLoginData();
    // if(localStorage.getItem('token')!=null){
    //   this.getNewsremind();
    // }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/topHeaderTrade.vue